import type { ComponentProps } from "react";
import { cn } from "~/lib/utils";

export function OperatorWorkspaceSurface({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "relative flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-md bg-white [--background:#fff]",
        "shadow-[0px_0px_0px_0.5px_var(--shadow-color),0px_1px_1px_-0.5px_var(--shadow-color),0px_3px_3px_-1.5px_var(--shadow-color),0px_6px_6px_-3px_var(--shadow-color)] dark:shadow-[inset_0_1px_0_0_rgba(255,255,255,0.05),inset_0_0_0_1px_rgba(255,255,255,0.02),0_0_0_1px_rgba(0,0,0,0.12),0_1px_1px_-0.5px_rgba(0,0,0,0.18),0_3px_3px_-1.5px_rgba(0,0,0,0.18)]",
        className,
      )}
      {...props}
    />
  );
}
